import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import { BaseFiltroComponent } from '@app/avaliagov/shared/components/base-filtro.component';
import { ButtonModule } from 'primeng/button';
import { Ciclo } from '@app/shared/models/ciclo';
import { SelectCicloComponent } from '@app/avaliagov/shared/components/select-ciclo/select-ciclo.component';
import { SelectOrgaoComponent } from '@app/avaliagov/shared/components/select-orgao/select-orgao.component';
import { SelectProcessoAvaliativoComponent } from '@app/avaliagov/shared/components/select-processo-avaliativo/select-processo-avaliativo.component';
import { Orgao } from '@app/shared/models/orgao';
import { ProcessoAvaliativo } from '@app/shared/models/processo-avaliativo';
import { ResultadoAvaliacaoInstitucionalService } from '../services/resultado-avaliacao-institucional.service';
import { UserService } from '@sigepe/ngx-sigepe-seguranca';

@Component({
	selector: 'sgp-filtro-consultar-resultado-avaliacao-institucional',
	standalone: true,
	imports: [ReactiveFormsModule, ButtonModule, SelectOrgaoComponent, SelectProcessoAvaliativoComponent, SelectCicloComponent],
	templateUrl: './filtro-consultar-resultado-avaliacao-institucional.component.html'
})
export class FiltroConsultarResultadoAvaliacaoInstitucionalComponent extends BaseFiltroComponent implements OnInit {
	private readonly userService = inject(UserService);
	protected readonly resultadoAvaliacaoService = inject(ResultadoAvaliacaoInstitucionalService);

	ngOnInit(): void {
		this.criarFormulario();
		this.selecionarOrgaoAutomaticamente();
	}

	pesquisar() {
		this.submetido = true;
		if (this.form.valid) {
			this.resultadoAvaliacaoService.converterFormularioParaFiltro(this.form);
			this.resultadoAvaliacaoService.pesquisarAlcance();
		} else {
			this.form.markAllAsTouched();
		}
	}

	limpar() {
		this.form.reset();
		this.submetido = false;
		this.resultadoAvaliacaoService.limpar();
		this.selecionarOrgaoAutomaticamente();
	}

	/**
	 * Se houver um órgão selecionado, habilita o campos processo avaliativo. Senão, desabilita-os.
	 * @param orgao
	 */
	onChangeOrgao(orgao: Orgao) {
		this.resetCampos(['processoAvaliativo', 'ciclo']);
		this.desabilitarCampos(['processoAvaliativo', 'ciclo']);
		this.submetido = false;
		if (orgao?.codigo) {
			this.habilitarCampos(['processoAvaliativo']);
			this.resultadoAvaliacaoService.listarProcessosAvaliativos(orgao.codigo);
		}
		this.resultadoAvaliacaoService.limparResultado();
	}

	/**
	 * Se houver um processo avaliativo selecionado, habilita o campo ciclo. Senão, desabilita-o.
	 * @param processoAvaliativo
	 */
	onChangeProcessoAvaliativo(processoAvaliativo?: ProcessoAvaliativo) {
		this.resetCampos(['ciclo']);
		this.desabilitarCampos(['ciclo']);
		this.submetido = false;
		if (processoAvaliativo) {
			this.habilitarCampos(['ciclo']);
			this.resultadoAvaliacaoService.listarCiclos(this.form.get('orgao')?.value?.codigo, processoAvaliativo.id!);
		}
		this.resultadoAvaliacaoService.limparResultado();
	}

	onChangeCiclo(ciclo: Ciclo | undefined) {
		this.resultadoAvaliacaoService.limparResultado();
	}

	/**
	 * Caso haja apenas um órgão, seleciona automaticamente e dispara ação de seleção de órgão.
	 */
	private selecionarOrgaoAutomaticamente() {
		if (this.resultadoAvaliacaoService.orgaos$) {
			this.userService.userData$.subscribe(userdata => {
				this.resultadoAvaliacaoService.orgaos$?.subscribe(orgaos => {
					const index = orgaos.findIndex(orgao => orgao.codigo === userdata.codigoOrgaoSiape);
					if (index !== -1) {
						const orgao = orgaos[index];
						this.form.get('orgao')?.setValue(orgao);
						this.form.get('orgao')?.disable();
						this.onChangeOrgao(orgao);
					}
				});
			});
		}
	}

	private criarFormulario(): void {
		this.form = this.fb.group({
			orgao: [undefined, Validators.required],
			processoAvaliativo: [{ value: undefined, disabled: true }, Validators.required],
			ciclo: [{ value: undefined, disabled: true }]
		});
	}
}
